export default "__VITE_ASSET__BHQ_t2KD__"